import * as Sentry from "@sentry/react";
import { sentryEnvironment } from "./config.js";

const isDev = process.env.NODE_ENV === "development";

export const initializeBugReporting = () => {
	Sentry.init({
		dsn:
			"https://e1b8be65a2562bdc5dfb70c890408cb1@o4508967038287872.ingest.us.sentry.io/4509232354557952",
		sendDefaultPii: true,
		integrations: [],
		environment: sentryEnvironment,
	});
};

export const leaveBreadcrumb = (message, metadata = null) => {
	if (isDev) {
		console.log(message, metadata);
	}
	Sentry.addBreadcrumb({
		message,
		data: metadata,
		level: "info",
	});
};

export const reportError = (err, metadata = null) => {
	if (isDev) {
		console.error(err, metadata);
	}
	Sentry.captureException(err, {
		level: "error",
		extra: metadata,
	});
};

export const reportInfo = (err, metadata = null) => {
	if (isDev) {
		console.info(err, metadata);
	}
	Sentry.captureException(err, {
		level: "info",
		extra: metadata,
	});
};

export const reportWarning = (err, metadata = null) => {
	if (isDev) {
		console.warn(err, metadata);
	}
	Sentry.captureException(err, {
		level: "warning",
		extra: metadata,
	});
};



// WEBPACK FOOTER //
// ./src/bugReporting.js